export class CustomerFilter {
  public name;
  public city;
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/filter/customer-filter.ts